import { Component, Input } from '@angular/core';
import {
  VgApiService,
  VgCoreModule,
  VgFullscreenApiService,
} from '@videogular/ngx-videogular/core';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss'],
  imports: [VgCoreModule, VgOverlayPlayModule],
})
export class PlayerComponent {
  public vgApi!: VgApiService;
  public fullscreen = false;

  @Input() videoUrl!: string;

  constructor(private fs: VgFullscreenApiService) {}

  changeFullscreen(e: any) {
    this.fullscreen = !this.fullscreen;
  }

  public async onPlayerReady(api: VgApiService): Promise<void> {
    this.vgApi = api;
    this.vgApi.volume = 0;

    this.vgApi.getDefaultMedia().subscriptions.canPlay.subscribe(async () => {
      setTimeout(() => {
        this.vgApi.play();
      }, 300);
    });

    this.vgApi.getDefaultMedia().subscriptions.ended.subscribe(async () => {});

    this.vgApi.getDefaultMedia().subscriptions.error.subscribe((error) => {
      console.log('VG ERROR', error);
    });
  }
}
